import { useCallback, useEffect, useRef, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { PHP_URL, PAYPAL_CLIENT_ID } from "../../config/env";
import useCart from "../../hooks/useCart";
import { itemPreis, throwError, Footer } from "./cart";
import * as math from "mathjs";

export default function Checkout(props) {
  const { disabled = false, onBestellung, onPrev, bestellungIsLoading } = props;
  const cart = useCart();
  const items = cart.items;
  const totalCost = cart.getTotal(itemPreis);
  const shippingCost = cart.getShippingCost();

  const customBestellnummerRef = useRef(
    Math.random().toString(36).substring(2, 10).toUpperCase(),
  );
  const customBestellnummer = customBestellnummerRef.current;
  const [loading, setLoading] = useState(true);

  const [hasPaidWithPayPal, setHasPaidWithPayPal] = useState(false);

  const itemCounts = useRef([]);
  useEffect(() => {
    (async () => {
      try {
        const response = await fetch(`${PHP_URL}/count.php?x=all`);
        const counts = await response.json();
        itemCounts.current = counts;
      } catch (error) {
        window.alert(
          "Da scheint etwas schief gelaufen zu sein. Bitte probiere es später nochmal oder wende dich an info@rock-im-garten.com für Hilfe.",
        );
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const getPurchaseUnitsItems = useCallback(() => {
    return [
      {
        invoice_id: customBestellnummer,
        amount: {
          breakdown: {
            item_total: {
              currency_code: "EUR",
              value: totalCost.toFixed(2),
            },
            shipping: {
              currency_code: "EUR",
              value: math.number(shippingCost),
            },
            tax_total: {
              currency_code: "EUR",
              value: math.number("0.00"),
            },
          },
          currency_code: "EUR",
          value: math.add(totalCost, shippingCost).toFixed(2),
        },
        items: items.map((item) => {
          const preis = itemPreis(item);
          const size = item.size ? item.size : "0";
          const option = item.option ? item.option : "0";
          const camper = item.amountCamper ? item.amountCamper : "0";
          const tent = item.amountTent ? item.amountTent : "0";
          const countSoFar =
            itemCounts.current.find(
              (c) =>
                c.ProductId ===
                `${item.id.toString()}-${item.size ?? ""}-${item.option ?? 0}`,
            )?.anzahl ?? 0;
          return {
            name: item.name,
            // TODO: wird eigentlich nicht mehr benötigt, da wir den späteren Rückgabewert von PayPal nicht mehr weiter verarbeiten; die Bestellinformationen sammeln wir stattdessen direkt aus `cart` zusammen.
            sku:
              item.id +
              "#" +
              size +
              "#" +
              camper +
              "#" +
              tent +
              "#" +
              option +
              "#" +
              countSoFar,
            unit_amount: { value: preis, currency_code: "EUR" },
            quantity: item.amount,
          };
        }),
      },
    ];
  }, [items, totalCost, shippingCost, itemCounts, customBestellnummer]);

  if (!hasPaidWithPayPal && cart.getTotal(itemPreis) === 0 && cart.getShippingCost() === 0) {
    return (
      <Wrapper onPrev={onPrev}>
        <button
          disabled={loading || bestellungIsLoading}
          className="button primary order"
          onClick={() => onBestellung({ bestellnummer: customBestellnummer })}
        >
          {bestellungIsLoading ? "Bestellung wird verarbeitet..." : loading ? "lädt..." : "Jetzt bestellen"}
        </button>
      </Wrapper>
    );
  }

  return (
    <Wrapper onPrev={onPrev}>
      {bestellungIsLoading ? <h1>Bestellung wird verarbeitet...</h1> : (
        <>
          <h3>Jetzt kostenpflichtig bestellen:</h3>
          <PayPalScriptProvider
            options={{ currency: "EUR", "client-id": PAYPAL_CLIENT_ID }}
          >
            <PayPalButtons
              disabled={disabled || loading}
              createOrder={(_data, actions) => {
                setHasPaidWithPayPal(true);
                setLoading(true);
                return actions.order.create({
                  purchase_units: getPurchaseUnitsItems(),
                });
              }}
              onError={(_data, _actions) => {
                setLoading(false);
                throwError();
              }}
              onApprove={(_data, actions) => {
                return actions.order.capture().then((details) => {
                  onBestellung({
                    bestellnummer: customBestellnummer,
                    payer_id: details.payer.payer_id,
                  });
                });
              }}
            />
          </PayPalScriptProvider>
        </>
      )}
    </Wrapper>
  );
}

function Wrapper(props) {
  return (
    <div className="cartBox">
      <div className="content">
        <div className="CartContainer">
          {props.children}
          <Footer onPrev={props.onPrev} />
        </div>
      </div>
    </div>
  );
}
